module.exports = "/packs/images/homepage/facilities/booking_activities~59b1da4f6f14f185b5cd21fc684485b8.jpg";